// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as MatrixData$LiteracyplanetClientSxEntry from "../academy/MatrixData.res.mjs";
import * as WordFlyersTypes$LiteracyplanetClientSxEntry from "./WordFlyersTypes.res.mjs";
import * as WordFlyersIndexQuery$LiteracyplanetClientSxEntry from "./WordFlyersIndexQuery.res.mjs";
import * as WordFlyersLevelQuery$LiteracyplanetClientSxEntry from "./WordFlyersLevelQuery.res.mjs";

function WordFlyersData$Provider$Data(props) {
  var gate = props.gate;
  var journey = props.journey;
  var queryIndex = WordFlyersIndexQuery$LiteracyplanetClientSxEntry.use();
  var match = React.useState(function () {
        return {
                loading: true,
                gates: [],
                units: [],
                scoresFound: false,
                journeyGate: ""
              };
      });
  var setData = match[1];
  var data = match[0];
  React.useEffect((function () {
          var fetchIndex = async function () {
            var res = await queryIndex(journey, gate);
            return setData(function (param) {
                        return res;
                      });
          };
          fetchIndex();
        }), [
        journey,
        gate
      ]);
  var match$1 = data.loading;
  var match$2 = Belt_Int.fromString(gate);
  var match$3 = MatrixData$LiteracyplanetClientSxEntry.useActivities(undefined, "word_flyers", match$1 || match$2 === undefined ? undefined : Belt_Option.map(Belt_Array.get(data.gates, match$2), (function (gate) {
                return gate.id;
              })));
  var onGetMatrixActivity = match$3[0];
  var isScoresFound = function (d) {
    return {
            loading: d.loading,
            gates: d.gates,
            units: d.units,
            scoresFound: Belt_Array.reduce(d.units, false, (function (acc, unit) {
                    if (acc) {
                      return acc;
                    } else {
                      return Belt_Array.some(unit.activities, (function (a) {
                                    var match = onGetMatrixActivity(a.id);
                                    if (typeof match !== "object") {
                                      return false;
                                    } else {
                                      return match._0.attempts > 0;
                                    }
                                  }));
                    }
                  })),
            journeyGate: d.journeyGate
          };
  };
  var journeys = WordFlyersTypes$LiteracyplanetClientSxEntry.Journeys.t;
  return React.createElement(WordFlyersTypes$LiteracyplanetClientSxEntry.Provider.make, {
              value: {
                journey: journey,
                journeys: journeys,
                gate: gate,
                data: isScoresFound(data),
                level: props.level,
                onGetMatrixActivity: onGetMatrixActivity
              },
              children: props.children
            });
}

var Data = {
  make: WordFlyersData$Provider$Data
};

function WordFlyersData$Provider(props) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var level = WordFlyersLevelQuery$LiteracyplanetClientSxEntry.use(user.userId);
  if (level === undefined) {
    return null;
  }
  var journey = Belt_Option.getWithDefault(props.optionalJourney, level.journey);
  var gate = Belt_Option.getWithDefault(props.optionalGate, level.gate);
  return React.createElement(WordFlyersData$Provider$Data, {
              journey: journey,
              gate: gate,
              level: level,
              children: props.children
            });
}

var Provider = {
  Data: Data,
  make: WordFlyersData$Provider
};

export {
  Provider ,
}
/* react Not a pure module */
